module.exports = __webpack_public_path__ + "img/MAPS.2d73739f.png";